import { post, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'
import { handleApiResponse } from './api_util';


async function createOrgCase(orgID,caseData){
    const payload={
        apiName: 'LivisiblyOrgApi',
        path: `orgs/${orgID}/cases`,
        options: {
          body: {
            case_data: caseData,
          }
        }
      }

      const restOperation = post(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }

  async function getOrgCases(orgID){

     const payload={
      apiName: 'LivisiblyOrgApi',
      path: `orgs/${orgID}/cases`

    }

    const restOperation = get(payload);


    const response = await restOperation.response;

    return processResponse(response)
  }

  async function getAllOrgCases(){

     const payload={
      apiName: 'LivisiblyOrgApi',
      path: `orgs/cases`

    }

    const restOperation = get(payload);


    const response = await restOperation.response;

    return processResponse(response)
  }

  async function getOrgCase(orgID,caseID){
    const payload={
      apiName: 'LivisiblyOrgApi',
      path: `orgs/${orgID}/cases/${caseID}`
    }

    const restOperation = get(payload);


    const response = await restOperation.response;
    return processResponse(response)
  }

  async function updateOrgCase(orgID,caseData){
    const payload={
        apiName: 'LivisiblyOrgApi',
        path: `orgs/${orgID}/cases`,
        options: {
          body: {
            case_data: caseData,
          }
        }
      }

      const restOperation = put(payload);


      const response = await restOperation.response;
      return processResponse(response)
  }

  async function archiveCase(caseID){
    // console.log(`in archiveCase, caseID=${caseID}`)
    const payload={
      apiName: 'LivisiblyOrgApi',
      path: `cases/${caseID}/archive`,
    }
    const restOperation = del(payload);
    const response = await restOperation.response;
    return processResponse(response)

  }

  async function reactivateCase(caseID){
    const payload={
      apiName: 'LivisiblyOrgApi',
      path: `cases/${caseID}/reactivate`,
    }
    const restOperation = post(payload);
    const response = await restOperation.response;
    return processResponse(response)
  }

  async function deleteCase(caseID){
    // Permanent, non-recoverable delete (DELETE /cases/{caseID}/delete).
    const payload={
      apiName: 'LivisiblyOrgApi',
      path: `cases/${caseID}/delete`,
    }
    const restOperation = del(payload);
    const response = await restOperation.response;
    return processResponse(response)
  }

// Create org case
export function useCreateOrgCase() {
    return async (orgID,caseData) => {
      try {
        const response = await createOrgCase(orgID,caseData);
        return handleApiResponse(['ORGCASES',orgID],'caseID',response, 'create');
      } catch (error) {
        console.error('Error creating org case:', error);
        throw error;
      }
    };
  }

  export function useGetOrgCases(orgID,shouldFetch=true){
    const result = useSWR(
      shouldFetch ? ['ORGCASES',orgID] : null,
      (path) => getOrgCases(orgID)
    );
    return result;
  }

  export function useGetAllOrgCases(shouldFetch=true){
    const result = useSWR(
      shouldFetch ? ['ORGCASES'] : null,
      (path) => getAllOrgCases()
    );
    return result;
  }

  export function useGetOrgCase(orgID,caseID, shouldFetch=true){
    const result = useSWR(
      shouldFetch ? [['ORGCASES', orgID], caseID] : null,
      ([path, orgID]) => getOrgCase(orgID, caseID)
    );
    return result;
  }

  // Update org cases
export function useUpdateOrgCase() {
    return async (orgID,updatedData) => {
      try {
        const response = await updateOrgCase(orgID,updatedData);
        return handleApiResponse(['ORGCASES',orgID],'caseID',response, 'update');
      } catch (error) {
        console.error('Error updating org case:', error);
        throw error;
      }
    };
  }


  // Archive org case
  export function useArchiveOrgCase() {
    return async (orgID,caseID) => {
      try {
        const response = await archiveCase(caseID);
        return handleApiResponse(['ORGCASES',orgID],'caseID',response, 'update');
      } catch (error) {
        console.error('Error archiving org case:', error);
        throw error;
      }
    };
  }

  // Reactivate (un-archive) org case
  export function useReactivateOrgCase() {
    return async (orgID,caseID) => {
      try {
        const response = await reactivateCase(caseID);
        return handleApiResponse(['ORGCASES',orgID],'caseID',response, 'update');
      } catch (error) {
        console.error('Error reactivating org case:', error);
        throw error;
      }
    };
  }

  // Permanently delete org case (non-recoverable). The case is tombstoned
  // (status=DELETED) rather than removed, so we 'update' the cache entry.
  export function useDeleteOrgCase() {
    return async (orgID,caseID) => {
      try {
        const response = await deleteCase(caseID);
        return handleApiResponse(['ORGCASES',orgID],'caseID',response, 'update');
      } catch (error) {
        console.error('Error deleting org case:', error);
        throw error;
      }
    };
  }
